import { render, staticRenderFns } from "./CoachGroupDetail.vue?vue&type=template&id=9346843c&scoped=true"
import script from "./CoachGroupDetail.vue?vue&type=script&lang=js"
export * from "./CoachGroupDetail.vue?vue&type=script&lang=js"
import style0 from "./CoachGroupDetail.vue?vue&type=style&index=0&id=9346843c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9346843c",
  null
  
)

export default component.exports